/**
组件编辑外层拖拽，可编辑按钮，缩放改变盒子大小
*/
<template>
  <div
          @click="handleTopWrapperClick"
          @touchend="handleMouseDownOnElement"
          :class="{active: this.active, 'components-edit-shape': edit}"
  >
  <!-- <div
            class="edit-shape-point"
            v-show="edit"
            v-for="item in (active ? pointList : [])"
            :key="item"
            :style="getPointStyle(item)"
    ></div> -->
    <slot></slot>
  </div>
</template>

<script>
  import runAnimations from '@/common/runAnimations'
  import Bus from '@/common/eventBus'

  export default {
    name: 'EditShape',
    props: {
      edit: {
        type: Boolean,
        default: false
      },
      active: {
        type: Boolean,
        default: false
      },
      defaultStyle: {
        require: true,
        type: Object
      },
      uuid: String
    },
    data() {
      return {
        // l = left, t = top, r = right, b = bottom
        pointList: ['lt', 'rt', 'lb', 'rb', 'l', 'r', 't', 'b'],
        // 上下左右 对应的 东南西北
        directionKey: {
          t: 'n',
          b: 's',
          l: 'w',
          r: 'e'
        }
      }
    },
    mounted() {
      this.animatePlaying = false;
      Bus.$on('RUN_ANIMATIONS', (uuid, animations) => {
        if (uuid !== this.uuid) {
          return;
        }
        // 正在执行的动画不允许插入新动画
        if(this.animatePlaying) return;
        let cssText = this.$el.style.cssText;
        this.animatePlaying = true;
        runAnimations(this.$el, animations, true, () => {
          this.$el.style.cssText = cssText
          this.animatePlaying = false;
        })
      })
    },
    methods: {
      /**
       * 获取point计算后样式
       * @param point
       * @returns {{}}
       */
      getPointStyle(point) {
        const pos = this.defaultStyle
        const height = pos.height
        const width = pos.width
        let hasT = /t/.test(point)
        let hasB = /b/.test(point)
        let hasL = /l/.test(point)
        let hasR = /r/.test(point)
        let newLeft = 0
        let newTop = 0
        if (point.length === 2) {
          newLeft = hasL ? 0 : width
          newTop = hasT ? 0 : height
        } else {
          // !#zh 上下点，宽度固定在中间
          if (hasT || hasB) {
            newLeft = width / 2
            newTop = hasT ? 0 : height
          }
          // !#zh 左右点，高度固定在中间
          if (hasL || hasR) {
            newLeft = hasL ? 0 : width
            newTop = height / 2
          }
        }
        const style = {
          marginLeft: (hasL || hasR) ? '-5px' : 0,
          marginTop: (hasT || hasB) ? '-5px' : 0,
          left: `${newLeft}px`,
          top: `${newTop}px`,
          cursor: point.split('').reverse().map(m => this.directionKey[m]).join('') + '-resize'
        }
        return style
      },
      /**
       * 点击事件，点击后设置当前元素为选中元素
       */
      handleTopWrapperClick(e) {
        e.stopPropagation()
        e.preventDefault()
      },
      /**
       * 鼠标选中元素拖拽事件
       * @param e
       */
      handleMouseDownOnElement(e) {
        console.log('333');
        // 抛出事件让父组件设置当前元素选中状态
        this.$emit('handleElementClick')

        // 去掉边框点点 直接选择背景图
        this.$emit('afterClick');

        // if (this.active) {
        //   this.$emit('afterClick');
        // }

        const pos = {...this.defaultStyle}
        let startY = e.changedTouches[0].clientY
        let startX = e.changedTouches[0].clientX
        let startTop = pos.top
        let startLeft = pos.left
        let firstTime='',lastTime='';
        firstTime = new Date().getTime();
        // let move = moveEvent => {
        //   // !#zh 移动的时候，不需要向后代元素传递事件，只需要单纯的移动就OK
        //   moveEvent.stopPropagation()
        //   // moveEvent.preventDefault()

        //   let currX = moveEvent.changedTouches[0].clientX
        //   let currY = moveEvent.changedTouches[0].clientY
        //   pos.top = currY - startY + startTop
        //   pos.left = currX - startX + startLeft
        //   console.log('1');
        //   this.$emit('resize', pos)
        // }
        // let up = () => {
        //   lastTime = new Date().getTime();
        //   if( (lastTime - firstTime) > 200){
        //     console.log('2');
        //     this.$emit('resize')
        //   }
        //   document.removeEventListener('touchmove', move, true)
        //   document.removeEventListener('touchend', up, true)
        // }
        // document.addEventListener('touchmove', move, true)
        // document.addEventListener('touchend', up, true)
        return true
      },
      /**
       * 鼠标点击可以的按钮resize事件
       * @param point
       * @param downEvent
       */
      handleMouseDownOnPoint(point) {
        console.log('1111');
        let downEvent = event;
        // 抛出事件让父组件设置当前元素选中状态
        this.$emit('handleElementClick')
        downEvent.stopPropagation()
        downEvent.preventDefault() // Let's stop this event.
        const pos = {...this.defaultStyle}
        console.log('pospospos:');
        console.log(pos);
        let height = pos.height
        let width = pos.width
        let top = pos.top
        let left = pos.left
        let startX = downEvent.changedTouches[0].clientX
        let startY = downEvent.changedTouches[0].clientY
        console.log('downEvent');
        console.log(downEvent);
        let move = moveEvent => {
          let currX = moveEvent.changedTouches[0].clientX
          let currY = moveEvent.changedTouches[0].clientY
          let disY = currY - startY
          let disX = currX - startX
          let hasT = /t/.test(point)
          let hasB = /b/.test(point)
          let hasL = /l/.test(point)
          let hasR = /r/.test(point)
          let newHeight = +height + (hasT ? -disY : hasB ? disY : 0)
          console.log('hasT:');
          console.log(hasT);
          console.log('disY:');
          console.log(disY);
          console.log('hasB:');
          console.log(hasB);
          let newWidth = +width + (hasL ? -disX : hasR ? disX : 0)
          console.log('newHeight:');
          console.log(newHeight);
          console.log('newWidth:');
          console.log(newWidth);
          pos.height = newHeight > 0 ? newHeight : 0
          pos.width = newWidth > 0 ? newWidth : 0
          pos.left = +left + (hasL ? disX : 0)
          pos.top = +top + (hasT ? disY : 0)
          console.log('3');
          this.$emit('resize', pos)
        }
        let up = () => {
          console.log('4');
          this.$emit('resize')
          document.removeEventListener('touchmove', move)
          document.removeEventListener('touchend', up)
        }
        document.addEventListener('touchmove', move)
        document.addEventListener('touchend', up)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .edit-shape-point {
    width: 10px;
    height: 10px;
    background-color: #fff;
    border: 1px solid #59c7f9;
    border-radius: 10px;
    position: absolute;
    z-index: 1001;
  }

  .components-edit-shape {
    cursor: move;
    &.active {
      outline: 1px dashed #25A589;
    }
    &:hover {
      outline: 1px dashed #25A589;
    }
  }
  .components-edit-shape-1 {
    cursor: move;
    &.active {
      outline: 1px dashed #25A589;
      z-index: 1001;
    }
    &:hover {
      outline: 1px dashed #25A589;
    }
  }
</style>
